import React from "react";
import LGModal from "../LGModal";
import AssetForm from "./AssetForm";
import { createAsset } from "../../api/assets";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const AssetModal = ({ open, onClose, onAssetCreated, companyId }) => {
  const { openSnack } = useSnack();

  const handleSubmit = async (values) => {
    try {
      const response = await createAsset(values);
      openSnack("Activo creado exitosamente", "success");
      onAssetCreated(response.data);
      onClose();
    } catch (error) {
      openSnack(handleError(error), "error");
      throw error; // Re-throw to let the form handle the error state
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <LGModal
      open={open}
      handleClose={onClose}
      header="Agregar Nuevo Activo"
    >
      <AssetForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        companyId={companyId}
      />
    </LGModal>
  );
};

export default AssetModal;
